<template>
  <section class="insuranceCards">
    <v-divider />
    <section class="insuranceCards-header">
      <section class="insuranceCards-condition">
        <h3>従業員ご本人様情報</h3>
        <v-btn @click="handleSubmit">条件変更</v-btn>
      </section>
      <section class="insuranceCards-info">
        <section class="insuranceCards-info_col">
          <span class="insuranceCards-info_label">生年月日</span>
          <span class="insuranceCards-info_value">{{ employeeBirthday }}</span>
        </section>
        <section class="insuranceCards-info_col">
          <span class="insuranceCards-info_label">満年齢</span>
          <span class="insuranceCards-info_value">{{ employeeAge }}歳</span>
          <!-- <span
            class="insuranceCards-info_note"
            @click.stop.prevent="openDialog('aboutAge')"
          >
            「年齢」について<img src="image/icon_info.svg"
          /></span> -->
        </section>
        <section class="insuranceCards-info_col">
          <span class="insuranceCards-info_label">性別</span>
          <span class="insuranceCards-info_value">{{ employeeGender }}</span>
        </section>
      </section>
      <section class="aboutAge">
        <h3>「年齢」について</h3>
        <p>各保険商品の「年齢(被保険者ごと)」の考え方は次のとおりです。</p>
        <ul>
          <li>
            <h4>・NEW (希) 保険</h4>
            <p>
              NEW(希)保険の「年齢」は保険年齢です。保険年齢は2027年1月1日（更新日）時点の満年齢で計算し、1年未満の端数は6カ月以下を切捨て、
              6カ月超を切上げます。
            </p>
          </li>
          <li>
            <h4>・団体医療保険制度（被保険者）</h4>
            <ol>
              <li>新規ご加入の方・・・加入日(注)時点の満年齢</li>
              <li>保障追加、加入内容変更の方・・・保険年度(毎年1月1日～翌年1月1日)ごとの最初の加入日時点の満年齢</li>
              <li>(注)毎月1日付で中途加入できます。</li>
            </ol>

          </li>
        </ul>
      </section>
    </section>
    <app-card
      v-for="(card, index) in cards"
      :key="index"
      :selected="selectedCards[index]"
      :title="card.title"
      :caption="card.caption"
      :browse="card.browse"
      :browse2="card.browse2"
      :avatar="card.avatar"
      :notes="card.notes"
      :identifier="card.identifier"
      :tooltip="card.tooltip"
      :disabled="disabledCards[index]"
      @onSelect="handleSelectCard($event, index)"
    >
      <template v-if="card.type === 'select'">
        <app-card-select-item
          v-for="(selectItem, selectIndex) in card.items"
          :key="selectIndex"
          v-model="selectItem.value"
          :title="selectItem.title"
          :subtitle="selectItem.subtitle"
          :label="selectItem.label"
          :items="selectItem.values"
          :disabled="!selectedCards[index] || disabledCards[index]"
          @change="handleSelectItemChange($event, index, selectIndex)"
          @initialevent="
            handleSelectItemChange(selectItem.value, index, selectIndex)
          "
        />
      </template>
      <app-expan-panel
        v-if="card.type === 'expan'"
        :panels="card.items"
        :items-open="card.itemsOpen"
        :disabled="!selectedCards[index] || disabledCards[index]"
        @onAction="handleAction"
      />
      <app-card-footer
        v-if="card.footer"
        :title="card.footer.title"
        :subtitle="card.footer.subtitle"
        :money="card.footer.money"
        :about="card.footer.about"
        :subtitle-action="card.footer.subtitleAction"
        :disabled="!selectedCards[index] || disabledCards[index]"
        @onAction="handleAction"
      />
    </app-card>
    <insurance-fixed-footer
      :insurance-premium="cards[0].footer.money"
      :monthly-insurance-premium="cards[0].footer.about"
      :monthly-group-medical-insurance="cards[1].footer.money"
    />
  </section>
</template>

<script>
import { cardMocks } from '@/globals/mocks';
import {
  initGeoupMedicalInsurace,
  setDefaultNewsCard,
  updateGroupMedicalInsurance,
  updateNewsCard,
} from '@/globals/mapper';
import { generateNumbers, getAgeByBirthday, getNewsInsuranseAge } from '@/utils/date';
import { mapActions } from 'vuex';
import InsuranceFixedFooter from './InsuranceFixedFooter.vue';
import dayjs from 'dayjs';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'InsuranceCards',
  components: {
    InsuranceFixedFooter,
  },
  props: {
    employeeInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      cards: cloneDeep(cardMocks),
      moneyItems: generateNumbers(1, 10).map((i) => i * 1000),
      selectedCards: {},
      disabledCards: {}
    };
  },
  computed: {
    employeeBirthday() {
      if (!this.employeeInfo) {
        return '1992年12月30日';
      }
      return dayjs()
        .year(this.employeeInfo.year)
        .month(this.employeeInfo.month - 1)
        .date(this.employeeInfo.day)
        .format('YYYY年M月D日');
    },
    employeeAge() {
      if (!this.employeeInfo) {
        return 30;
      }
      return getAgeByBirthday({
        year: this.employeeInfo.year,
        month: this.employeeInfo.month,
        date: this.employeeInfo.day,
      });
    },
    employeeGender() {
      return this.employeeInfo && this.employeeInfo.gender === 0
        ? '男性'
        : '女性';
    },
    genderInEnglish() {
      return this.employeeInfo && this.employeeInfo.gender === 0
        ? 'male'
        : 'female';
    },
    GroupMedicalInsuranceCard() {
      return this.card[1];
    },
    newsCardDisabled() {
      return !this.selectedCards[0] || this.disabledCards[0];
    },
  },
  watch: {
    newsCardDisabled(disabled) {
      if (disabled) {
        this.$set(this.cards[0].footer, 'money', null);
        this.$set(this.cards[0].footer, 'about', null);
      } else {
        this.handleSelectItemChange(this.cards[0].items[0].value, 0, 0);
      }
    },
  },
  mounted() {
    // Initializing cards state
    this.changeCardsSelection();
    this.changeDisabledCards();

    // News preparation
    setDefaultNewsCard(this.cards[0]);
    this.updateNewsCardState();

    // Group medical insurance preparation
    initGeoupMedicalInsurace(this.cards[1], this.employeeAge);
    this.updateGroupMedicalInsurance();
  },
  methods: {
    ...mapActions('dialog', ['openDialog', 'closeDialog']),
    updateGroupMedicalInsurance(insuranceType) {
      updateGroupMedicalInsurance(
        this.cards[1],
        this.employeeAge, {
          disabled: !this.selectedCards[1],
        },
        insuranceType
      );
    },
    updateNewsCardState() {
      const cardState = updateNewsCard(
        this.cards[0],
        getNewsInsuranseAge(this.employeeInfo),
        this.genderInEnglish
      );
      this.$set(this.disabledCards, 0, cardState.disabled);
    },
    // eslint-disable-next-line no-unused-vars
    handleSelectItemChange(value, cardIndex, selectIndex) {
      // News card
      if (cardIndex === 0) {
        this.updateNewsCardState();
      }
    },
    changeCardsSelection() {
      this.selectedCards = this.cards.reduce(
        (previousValue, _currentValue, currentIndex) => {
          previousValue[currentIndex] = true;

          return previousValue;
        },
        {}
      );
    },
    changeDisabledCards() {
      this.disabledCards = this.cards.reduce(
        (previousValue, _currentValue, currentIndex) => {
          if (currentIndex === 0) {
            previousValue[currentIndex] =
              this.employeeAge >= 15 &&
              this.employeeAge <= 70
                ? false
                : true;
          } else {
            previousValue[currentIndex] = false;
          }
          return previousValue;
        },
        {}
      );
    },
    handleSubmit() {
      this.$emit('submit', {
        year: this.employeeInfo.year,
        month: this.employeeInfo.month,
        day: this.employeeInfo.day,
        gender: this.employeeInfo.gender,
      });
    },
    handleSelectCard(event, index) {
      this.$set(this.selectedCards, index, event);
      this.$nextTick(() => {
        if (index === 1) {
          this.updateGroupMedicalInsurance();
        }
      });
    },
    handleAction(action) {
      if (!action) {
        return;
      }
      switch (action.type) {
        case 'open-dialog':
          this.openDialog(action.payload);
          break;
        case 'updateGroupMedicalInsurance':
          this.updateGroupMedicalInsurance(action.insuranceType);
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.insuranceCards {
  &-header {
    margin-bottom: 81px;
  }
  &-condition {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    h3 {
      font-size: 18px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.28;
      letter-spacing: normal;
      text-align: left;
      color: #575757;
      margin-bottom: 0;
    }
    &::v-deep .v-btn {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: 1.82px;
      text-align: left;
      color: #333;
      border-radius: 5px;
      border: solid 1px #ccc;
      box-shadow: none;
      width: 120px;
      height: 27px;
      background-color: #fff;
    }
  }
  &-info {
    display: flex;
    padding: 15px 20px;
    background-color: #f4f4f4;
    border-bottom: solid 1px #ccc;
    justify-content: space-around;

    &_label {
      display: inline-block;
      min-width: 73px;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      border-radius: 3px;
      background-color: #999;
      padding: 4px 10px;
      margin-right: 12px;
    }
    &_note {
      margin-right: 9px;
      font-size: 13px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.54;
      letter-spacing: 1.69px;
      text-align: left;
      color: #999;
      cursor: pointer;
      img {
        opacity: 0.7;
      }
    }
    &_value {
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.31;
      letter-spacing: normal;
      text-align: left;
      color: #333;
    }
    @media screen and (max-width: 880px) {
      flex-direction: column;
      padding: 10px;
      &:last-child {
        margin-right: 0;
      }
      &_col {
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
      &_label {
        font-size: 12px;
        padding: 4px;
        min-width: 60px;
      }
    }
  }
  .aboutAge{
    font-size: 12px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #999;
    margin-top: 5px;
    margin-bottom: 3px;
    white-space: pre-wrap;

    h3{
      font-size: 13px;
      font-weight: 700;
      line-height: 1.54;
      margin-bottom: 5px;
      padding-top: 3px;
    }

    p{
      line-height: 1.75;
      margin-bottom: 5px;
    }

    ul{
      padding-left: 0;

      li{
          margin-bottom: 5px;
          padding-left: 1em;
        h4{
          font-weight: 700;
          line-height: 1.58;
          text-indent: -1em;
          margin-bottom: 0;
          color: #999;
        }

        p{
        }

        ol{
          padding-left: 0;
          li{
            padding-left: 0;
          }
        }
      }
    }
  }
}
// mobile
@media screen and (max-width: 767px) {
  .insuranceCards {
    &-condition {
      padding: 10px;
      &::v-deep .v-btn {
        width: 80px;
      }
    }
  }
}
</style>
